import {
  List,
  Datagrid,
  TextField,
  NumberField,
  TopToolbar,
  ExportButton,
  CreateButton,
  DeleteButton,
  useRecordContext,
} from 'react-admin';

interface Role {
  id: number;
  name: string;
  description?: string;
  user_count?: number;
  permission_count?: number;
}

const RoleListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const ConditionalDeleteButton = () => {
  const record = useRecordContext<Role>();

  if (!record || (record.user_count && record.user_count > 0)) {
    return null;
  }

  return <DeleteButton />;
};

export const RoleList = () => (
  <List
    actions={<RoleListActions />}
    perPage={50}
    sort={{ field: 'name', order: 'ASC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="name" />
      <TextField source="description" />
      <NumberField source="user_count" label="Users" />
      <NumberField source="permission_count" label="Permissions" />
      <ConditionalDeleteButton />
    </Datagrid>
  </List>
);
